const translations = {
    connectionsManager: 'Connections Manager',
    continue: 'Continue',
    eaVisionConnectionGuidance: 'You may need to sync your EAVision flights in our',
    selectDroneMake: 'Select Drone Make'
};

export default translations;
